<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "cari"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/cari.vue